<template>
	<div style="height: 100%">
		<layout-app-bar />
		<layout-drawer />
		<layout-view />
		<layout-footer />
	</div>
</template>

<script>
import LayoutAppBar from '@/components/layout/LayoutAppBar';
import LayoutDrawer from '@/components/layout/LayoutDrawer';
import LayoutFooter from '@/components/layout/LayoutFooter';
import LayoutView from '@/components/layout/LayoutView';

export default {
	name: 'LayoutIndex',

	components: {
		LayoutAppBar,
		LayoutDrawer,
		LayoutFooter,
		LayoutView,
	},
};
</script>
